import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import { DataResponse, InstaLearn, InstaLearnTopic } from '../models';

@Injectable({
  providedIn: 'root'
})
export class InstaLearnApiService {
  constructor(private readonly httpService: HttpService) { }

  public getInstaLearns(queryParams: { limit?: number, offset?: number, sort?: string, topic?: string, showOnlyUnread?: boolean } = {}): Observable<DataResponse<InstaLearn>> {
    const params = new HttpParams({ fromObject: queryParams });
    return this.httpService.get<DataResponse<InstaLearn>>('instalearns', params);
  }

   public getInstaLearnTopics(queryParams: { offset?: number, limit?: number, hideEmpty?: boolean, sort?: string } = { sort: 'weight:ASC' }): Observable<DataResponse<InstaLearnTopic>> {
    const params = new HttpParams({ fromObject: queryParams });
    return this.httpService.get<DataResponse<InstaLearnTopic>>('instalearn-topics', params);
  }

  public markInstaLearnAsViewed(id: string): Observable<void> {
    return this.httpService.post<void>(`instalearn/mark-as-viewed/${id}`, null);
  }

  public likeInstaLearn(id: string): Observable<void> {
    return this.httpService.post<void>(`like/node/${id}`, {});
  }

  public removeLikeInstaLearn(id: string): Observable<void> {
    return this.httpService.post<void>(`unlike/node/${id}`, {});
  }

}